import Vue from "vue"

export default Vue.extend({
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        width="1em"
        height="1em"
      >
        <path d="M15.96 14.3a8.9 8.9 0 10-1.65 1.65l7.72 7.71a1.16 1.16 0 001.63-1.63l-7.7-7.73zm-7.03 1.18a6.56 6.56 0 110-13.12 6.56 6.56 0 010 13.12z" />
      </svg>
    )
  }
})
